const events = {
  INTEGRATIONS_CONNECT_MOUNT: 'integrations:connect:mount',
};

export { events };
export default events;
